"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var ScheduledTransparentIcon = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 36 35", fill: "currentColor", width: size || '36', height: size || '35' }, props),
        React.createElement("path", { fill: "currentColor", d: "M1 5.992h34a1 1 0 0 1 1 1v4.991H0V6.992a1 1 0 0 1 1-1zM35 35H1a1 1 0 0 1-1-1V13.98h36V34a1 1 0 0 1-1 1zM4 0h3v5.992H4V0zm25 0h3v5.992h-3V0zM5 18.974h5v4.993H5v-4.993z", opacity: ".6", fillRule: "evenodd" })));
};
ScheduledTransparentIcon.displayName = 'ScheduledTransparentIcon';
exports.default = ScheduledTransparentIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ScheduledTransparentIcon.js.map